module.exports = __webpack_public_path__ + "static/media/ds_cover-slide.22f9fdb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/expect-more/assets/ds_cover-slide.png
// module id = 239
// module chunks = 0